import {
    Box,
    FormControlLabel,
    Grid,
    Radio,
    RadioGroup,
    Theme,
    Typography
} from "@mui/material";
import { InfoIconOutlined } from "../../../assets/SvgIcons";
import {
    FormikContextType,
    useFormikContext
} from "formik";
import dayjs from "dayjs";
import { TextDatePicker } from "../../onboarding/DatePickerWithTextFeild";
import { MFSubmitButton } from "../../../lib/formik";
import {
    currentDate,
    currentFinancialYear,
    previousFinancialYear,
    statementTitleMap,
    Values
} from "./stmtCommon";
import { useSelector } from "react-redux";
import { RootStateType } from "../../../redux-store/reducers";
import { LoadingButton } from "@mui/lab";

const frequencyMap: Array<{ label: string; value: string; }> = [
    // {
    //     label: "Current Financial Year",
    //     value: "currentFinancialYear"
    // },
    // {
    //     label: "Previous Financial Year",
    //     value: "previousFinancialYear"
    // },
    {
        label: "As on Date",
        value: "asOnDate"
    },
    // {
    //     label: "Specific Period",
    //     value: "specificPeriod"
    // }
]

export default function StmtForm(
    {
        selectedStmt,
        isFormSubmitting,
        isDownloading
    }: {
        selectedStmt: string;
        isFormSubmitting: boolean;
        isDownloading: boolean;
    }
): JSX.Element {

    const { panNo: applicantPanNo = "", } = useSelector((store: RootStateType) => store.id)

    const {
        values,
        setValues
    }: FormikContextType<Values> = useFormikContext();

    const handleFrequencyChange = ({ target: { value: selectedFrequency } }: React.ChangeEvent<HTMLInputElement>) => {

        let fromDate = dayjs(currentDate)
        let toDate = dayjs(currentDate)

        if (selectedFrequency === "currentFinancialYear") {
            fromDate = currentFinancialYear.fromDate
            toDate = currentFinancialYear.toDate
        } else if (selectedFrequency === "previousFinancialYear") {
            fromDate = previousFinancialYear.fromDate
            toDate = previousFinancialYear.toDate
        } else if (selectedFrequency === "asOnDate") {
            fromDate = dayjs(new Date(1990, 0, 1))
            toDate = dayjs(currentDate)
        }

        setValues({
            frequency: selectedFrequency,
            fromDate,
            toDate
        })
    }

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                rowGap: "20px"
            }}
        >
            {/* <Typography
                variant="h2"
                sx={(theme: Theme) => ({
                    letterSpacing: "0.01px",
                    color: theme.palette.text.primary
                })}
            >
                {statementTitleMap[selectedStmt]}
            </Typography> */}
            {/* <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    columnGap: "5px",
                }}
            > */}
            {/* <Box
                sx={{
                    flexShrink: 0,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                }}
            >
                <InfoIconOutlined />
            </Box> */}
            {/* <Typography
                component="span"
                variant='subtitle_500'
                sx={(theme: Theme) => ({
                    fontWeight: 400,
                    color: `${theme.palette.text.secondary}B2`
                })}
            > */}
            {/* Statement Downloaded at the PAN Level :{" "} */}
            {/* Statement at the PAN Level :{" "} */}
            {/* <Typography
                    component="span"
                    variant='subtitle_500'
                    sx={{ fontWeight: 600 }}
                >
                    {applicantPanNo ?? ""}
                </Typography> */}
            {/* </Typography> */}
            {/* </Box> */}
            {/* <Typography
                variant="subtitle_500"
                sx={(theme: Theme) => ({
                    fontWeight: 400,
                    color: theme.palette.text.primary,
                })}
            >
                Select Frequency
            </Typography> */}
            {/* <RadioGroup
                row
                aria-labelledby="select-frequency"
                value={values.frequency}
                onChange={handleFrequencyChange}
                sx={{ columnGap: "35px" }}
            >
                {frequencyMap.map(({ label, value }) => (
                    <FormControlLabel
                        key={value}
                        value={value}
                        control={<Radio size="small" />}
                        label={label}
                        slotProps={{
                            typography: {
                                sx: (theme: Theme) => ({
                                    ...theme.typography.subtitle_500,
                                    fontWeight: 400,
                                    color: theme.palette.text.primary
                                })
                            }
                        }}
                        disabled={isDownloading}
                    />
                ))}
            </RadioGroup> */}
            {/* <Grid
                container
                columnSpacing={3}
                rowSpacing={2}
            > */}
            {/* <Grid
                    item
                    xs={12}
                    lg={6}
                >
                    <TextDatePicker
                        name="fromDate"
                        label="From Date *"
                        maxDate={currentDate}
                        disabled={(values.frequency !== "specificPeriod") || isDownloading}
                    />
                </Grid> */}
            {/* <Grid
                    item
                    xs={12}
                    lg={6}
                >
                    <TextDatePicker
                        name="toDate"
                        label="To Date *"
                        maxDate={currentDate}
                        disabled={(values.frequency !== "specificPeriod") || isDownloading}
                    />
                </Grid> */}
            {/* <Grid item xs={12} lg={6} sx={{ display: { xs: "none", lg: "block" } }} /> */}
            {/* <Grid
                    item
                    xs={12}
                    lg={6}
                > */}
            <LoadingButton
                loadingPosition="center"
                type="submit"
                loading={isFormSubmitting}
                variant="contained"
                sx={(theme: Theme) => ({
                    color: theme.palette.textDark.primary,
                    backgroundColor: theme.palette.primary[500],
                    padding: "5px 10px",
                    width: { xs: "100%", sm: "fit-content" },//61a
                    ...theme.typography.body_500
                })}
                disabled={isDownloading}
            >
                Get Portfolio Data
            </LoadingButton >
            {/* </Grid>
            </Grid> */}
        </Box >
    )
}